import { Component, OnInit } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';

import { HomeService } from './home.service';
import { DialogService } from '../shared/service/dialog.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
})
export class HomeComponent implements OnInit {

    //#region properties

    public data: string;

    //#endregion

    //#region ctor

    constructor(private flash: NotificationsService, private service: HomeService, private dialog: DialogService) { }

    //#endregion

    //#region Component life cycle event

    ngOnInit() {
    }

    //#endregion

    //#region public methods

    public success = () =>  this.flash.success('Success', 'This is a success message');
    public warn = () =>  this.flash.warn('Warning', 'This is a warning message');
    public error = () => this.flash.error('Error', 'This is an error message');

    public bug = () => {
        let a: string = null;
        return a.length; //should throw an error
    };

    public fetch = () => {
        this.service.lorem()
            .then(x => this.data = x)
    }

    public confirm = () => {
        return this.dialog.confirm()
            .then(x => this.flash.success('Confirmed'))
            .catch(x => this.flash.error('Canceled'));
    }

    //#endregion


}
